module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.getStatus))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-745c481e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/QueueStatusComponent.vue
// module id = 1325
// module chunks = 2